import { render, staticRenderFns } from "./ConceptsBrowser.vue?vue&type=template&id=3054c4b4"
import script from "./ConceptsBrowser.vue?vue&type=script&lang=js"
export * from "./ConceptsBrowser.vue?vue&type=script&lang=js"
import style0 from "./ConceptsBrowser.vue?vue&type=style&index=0&id=3054c4b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/.pnpm/vuetify-loader@1.7.3_uhb5aaqqgawn4pxsnzso5z623i/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLabel } from 'vuetify/lib/components/VLabel';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VLabel,VSwitch})
